<template>
    <b-card class="block__objectiveListProduction">

      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>
            {{ name }}
          </PuSkeleton>
          <span style="position: absolute;right: 15px;">
            <PuSkeleton :loading="isLoading" :count="1" width='60'>
              {{ getCategorieWinPrime() }}
            </PuSkeleton>
          </span>
        </p>
      </header>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of lists" :key="index" :class="index !== lists.length - 1 ? 'border-bottom' : ''">
          <div class="entete" v-if="!list.proCriteria.chooseAgent">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>
              <div class="title" style="max-width: 800px;">
                  {{list.proCriteria.name}}
              </div>
            </PuSkeleton>
            <PuSkeleton :loading="isLoading" :count="1" width='20px'>
              <div class="number" v-if="list.userProTrackingNumbers[0] && list.userProTrackingNumbers[0].currentPrime != null">
                {{ list.userProTrackingNumbers[0].currentPrime }}
                <span>/ {{list.proCriteria.prime}}</span>
              </div>
              <div class="number" v-else>
                - <span>/ {{list.proCriteria.prime}}</span>
              </div>
            </PuSkeleton>
          </div>
          <div class="label" v-if="!list.proCriteria.chooseAgent">
            <div class="left">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <div class="title">
                  Objectif
                </div>
                <span v-if="list.objective != null && !list.proCriteria.variableObjective">
                  {{ list.objective }} {{ list.proCriteria.valueType }}
                </span>
                <span v-if="list.proCriteria.variableObjective">
                  {{ list.proCriteria.variableObjectiveText }} : {{ list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueNational : '-' }} {{ list.proCriteria.valueType }}
                </span>
              </PuSkeleton>

              <PuSkeleton :loading="isLoading" :count="1" width='200px'>
                <div class="wrapper">
                  <b-progress :max="list.proCriteria.variableObjective && list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueNational : list.objective" :value="(list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueN : 0)"
                              :class="isPostive((list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueN : 0) , list.objective, list.reverseObjective)">
                  </b-progress>
                  <p class="value">
                    {{(list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueN : 0) }} {{ list.proCriteria.valueType }}
                  </p>
                </div>
              </PuSkeleton>
            </div>
            <div class="right">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <span v-if="list.objective != null || list.proCriteria.variableObjective">
                  % de réalisation {{ Math.round(list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].realisationPercent : 0) }} %
                </span>
              </PuSkeleton>
            </div>
          </div>
          <div class="label" v-if="list.userProTrackingNumbers[0] && list.userProTrackingNumbers[0].valueN1 && !list.proCriteria.chooseAgent">
            <div class="left">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <div class="title">
                  Réalisée n-1
                </div>
              </PuSkeleton>
              <PuSkeleton :loading="isLoading" :count="1" width='200px'>
                <div class="wrapper">
                  <b-progress :max="list.objective" :value="list.userProTrackingNumbers[0].valueN1">
                  </b-progress>
                  <p class="value" :class="list.color">
                    {{ (list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].valueN1 : 0) }} {{ list.proCriteria.valueType }}
                  </p>
                </div>
              </PuSkeleton>
            </div>
          </div>

                    <div class="entete" v-if="list.proCriteria.chooseAgent">
                      <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                        <div class="title" style="max-width: 800px;">
                          {{list.proCriteria.name}}
                        </div>
                      </PuSkeleton>
                      <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                        <div class="number" v-if="list.userProTrackingNumbers[0] && list.userProTrackingNumbers[0].currentPrime != null">
                          {{ list.userProTrackingNumbers[0].currentPrime }}
                          <span>/ {{list.proCriteria.prime}}</span>
                        </div>
                        <div class="number" v-else>
                          - <span>/ {{list.proCriteria.prime}}</span>
                        </div>
                      </PuSkeleton>
                    </div>
                    <div class="label" v-if="list.proCriteria.chooseAgent">
                      <div class="left">
                        <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                          <div class="title">
                            Objectif
                          </div>
                          <span>
                            {{ list.objective }} {{ list.proCriteria.valueType }}
                          </span>
                        </PuSkeleton>
                        <div v-if="list.userProTrackingNumbers[0]">
                          <PuSkeleton :loading="isLoading" :count="list.userProTrackingNumbers[0].agents.length" width='200px'
                                      v-for="(user,index) of list.userProTrackingNumbers[0].agents" :key="index">
                            <div class="wrapper">
                              <div class="font-weight-bold" style="max-width: 250px; min-width: 250px;">
                                {{ user.fullName }}
                              </div>
                              <b-progress :max="list.objective" :value="user.valueN"
                                          :class="isPostive(user.valueN, list.objective, list.reverseObjective)">
                              </b-progress>
                              <p class="value" :class="list.color">
                                {{ user.valueN }} {{ list.proCriteria.valueType }}
                              </p>
                            </div>
                          </PuSkeleton>
                        </div>

                      </div>
                      <div class="right">
                        <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                          <span v-if="list.objective != null">
                            % de réalisation {{ Math.round(list.userProTrackingNumbers[0] ? list.userProTrackingNumbers[0].realisationPercent : 0) }} %
                          </span>
                        </PuSkeleton>
                      </div>
                    </div>
        </b-list-group-item>
      </b-list-group>

    </b-card>
</template>


<script>

export default {
name:"wrapperPROList",
  props:{
    lists:{
      default: () => {
        return []
        }
      },
    name : {
      default: null
    },
    isLoad:{
      default: true
    }
  },
  data(){
    return {
      isLoading:true,
      datalists: {
        }
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
  },
  methods:{
    isPostive(value,qualificatifValue = 0, isReverse = false){
      const percent = Math.round((value * 100) / qualificatifValue);
      if (isReverse){
        return 85 > percent ?  'green' : 'yellow';
      }
      return 85 <= percent ?  'green' : 'yellow';
    },
    getPercent(value, objective){
      return Math.round((value * 100) / objective).toLocaleString();
    },
    getCategorieWinPrime(){
        return this.lists
            .map( v => (v.userProTrackingNumbers[0] ? v.userProTrackingNumbers[0].currentPrime : 0) )
            .reduce( (sum, current) => sum + current, 0 );
    }
  },
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;
      this.isLoading = this.isLoad;
    },
  },
}
</script>
